import { Routes } from '@angular/router';
import { ResultPageGuard } from './core/guard/result-page.guard';
import { resultPageResolver } from './core/resolver/result-page.resolver';
import {
  AveragePeakB2B,
  ConsumptionHelpB2B,
  ConsumptionsB2B,
  EnergyB2B,
  HasSolarPanelsB2B,
  KnowConsumptionB2B,
  MeterTypeB2B,
  MoreThan8Sites,
  Multisite,
  SiteNumberB2B,
  SmartMeterB2B,
  SolarPanelKvaB2B,
  ZipCodeB2B,
} from './core/service/questions/config/questions-config-b2b';
import { Result } from './core/service/questions/questions-common';
import {
  BoilerYearB2C,
  CertificationPVB2C,
  EnergyB2C,
  HabitantNumberB2C,
  HabitationTypeB2C,
  HabitationVolumeB2C,
  HabitationYearB2C,
  HasElectricVehicleB2C,
  HeatingPumpTypeB2C,
  HeatingTypeB2C,
} from './core/service/questions/config/questions-config-b2c';
import { ClientType, TypeDetectorService } from './core/service/type-detector.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo:
      TypeDetectorService.detectType() === ClientType.B2C
        ? new EnergyB2C().getEnTranslatedUrl()
        : new SiteNumberB2B().getEnTranslatedUrl(),

    pathMatch: 'full',
  },
  {
    path: new SiteNumberB2B().getEnTranslatedUrl(),
    loadComponent: () => import('./features/site-number/site-number.component').then((m) => m.SiteNumberComponent),
    pathMatch: 'full',
  },
  {
    path: new ZipCodeB2B().getEnTranslatedUrl(),
    loadComponent: () => import('./features/zip-code/zip-code.component').then((m) => m.ZipCodeComponent),
    pathMatch: 'full',
  },
  {
    path: new EnergyB2B().getEnTranslatedUrl(),
    loadComponent: () => import('./features/energy/energy.component').then((m) => m.EnergyComponent),
    pathMatch: 'full',
  },
  {
    path: new KnowConsumptionB2B().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/know-consumptions/know-consumptions.component').then((m) => m.KnowConsumptionsComponent),
    pathMatch: 'full',
  },
  {
    path: new HasSolarPanelsB2B().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/solar/has-solar-panel/has-solar-panel.component').then((m) => m.HasSolarPanelComponent),
    pathMatch: 'full',
  },
  {
    path: new CertificationPVB2C().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/pv-certification/pv-certification.component').then((m) => m.PvCertificationComponent),
    pathMatch: 'full',
  },
  {
    path: new SolarPanelKvaB2B().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/solar/solar-panel-kva/solar-panel-kva.component').then((m) => m.SolarPanelKvaComponent),
    pathMatch: 'full',
  },
  {
    path: new HasElectricVehicleB2C().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/has-electric-vehicle/has-electric-vehicle.component').then(
        (m) => m.HasElectricVehicleComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: new SmartMeterB2B().getEnTranslatedUrl(),
    loadComponent: () => import('./features/smart-meter/smart-meter.component').then((m) => m.SmartMeterComponent),
    pathMatch: 'full',
  },
  {
    path: new MeterTypeB2B().getEnTranslatedUrl(),
    loadComponent: () => import('./features/meter-type/meter-type.component').then((m) => m.MeterTypeComponent),
    pathMatch: 'full',
  },
  {
    path: new AveragePeakB2B().getEnTranslatedUrl(),
    loadComponent: () => import('./features/peak-info/average-peak.component').then((m) => m.AveragePeakComponent),
    pathMatch: 'full',
  },
  {
    path: new ConsumptionsB2B().getEnTranslatedUrl(),
    loadComponent: () => import('./features/consumptions/consumptions.component').then((m) => m.ConsumptionsComponent),
    pathMatch: 'full',
  },
  {
    path: new ConsumptionHelpB2B().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/consumptions-help/consumptions-help.component').then((m) => m.ConsumptionsHelpComponent),
    pathMatch: 'full',
  },
  {
    path: new Multisite().getEnTranslatedUrl(),
    loadComponent: () => import('./features/multisite/multisite.component').then((m) => m.MultisiteComponent),
    pathMatch: 'full',
  },
  {
    path: new Result().getEnTranslatedUrl(),
    loadComponent: () =>
      TypeDetectorService.detectType() === ClientType.B2C
        ? import('./features/results/results-b2c/results-b2c.component').then((m) => m.ResultsB2cComponent)
        : import('./features/results/result-b2b/results-b2b.component').then((m) => m.ResultsB2bComponent),
    pathMatch: 'full',
    canActivate: [ResultPageGuard],
    resolve: { simulationStartup: resultPageResolver },
  },
  {
    path: new MoreThan8Sites().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/too-much-sites/too-much-sites.component').then((m) => m.TooMuchSitesComponent),
    pathMatch: 'full',
  },
  {
    path: new HabitationTypeB2C().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/habitation-type/habitation-type.component').then((m) => m.HabitationTypeComponent),
    pathMatch: 'full',
  },
  {
    path: new HabitationVolumeB2C().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/habitation-volume/habitation-volume.component').then((m) => m.HabitationVolumeComponent),
    pathMatch: 'full',
  },
  {
    path: new HabitationYearB2C().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/habitation-year/habitation-year.component').then((m) => m.HabitationYearComponent),
    pathMatch: 'full',
  },
  {
    path: new HabitantNumberB2C().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/habitant-number/habitant-number.component').then((m) => m.HabitantNumberComponent),
    pathMatch: 'full',
  },
  {
    path: new HeatingTypeB2C().getEnTranslatedUrl(),
    loadComponent: () => import('./features/heating-type/heating-type.component').then((m) => m.HeatingTypeComponent),
    pathMatch: 'full',
  },
  {
    path: new BoilerYearB2C().getEnTranslatedUrl(),
    loadComponent: () => import('./features/boiler-year/boiler-year.component').then((m) => m.BoilerYearComponent),
    pathMatch: 'full',
  },
  {
    path: new HeatingPumpTypeB2C().getEnTranslatedUrl(),
    loadComponent: () =>
      import('./features/heating-pump-type/heating-pump-type.component').then((m) => m.HeatingPumpTypeComponent),
    pathMatch: 'full',
  },
  {
    path: 'profil-not-found',
    loadComponent: () =>
      import('./features/profil-not-found/profil-not-found.component').then((m) => m.ProfilNotFoundComponent),
    pathMatch: 'full',
  },
  {
    path: 'error',
    loadComponent: () => import('./features/error/error.component').then((m) => m.ErrorComponent),
    pathMatch: 'full',
  },
  {
    path: '**',
    loadComponent: () =>
      TypeDetectorService.detectType() === ClientType.B2C
        ? import('./features/results/results-b2c/results-b2c.component').then((m) => m.ResultsB2cComponent)
        : import('./features/results/result-b2b/results-b2b.component').then((m) => m.ResultsB2bComponent),
    pathMatch: 'prefix',
    canActivate: [ResultPageGuard],
    resolve: { simulationStartup: resultPageResolver },
  },
];
